<template>
  <section id="howWorksSection" class="how-works-section">
    <b-container>
      <b-row>
        <b-col sm="12">
          <h4 class="title-how-works text-center">{{$t('title_how_works')}}</h4>
        </b-col>
      </b-row>
      <carousel :autoplay="true"
                :autoplayHoverPause="true"
                :items="1"
                :loop="false"
                :autoWidth="true"
                :nav="false"
                :dots="true"
                :margin="32"
                :responsive="{ 600: { items: 3 } }">
      <div v-for="slide in slides" :key="slide.id" class="slider-content-container">
        <img v-if="$i18n.locale === 'en'" class="slider-img" :src="slide.imageUrlEng" :alt="'Slide ' + slide.id">
        <img v-else-if="$i18n.locale === 'uk'" class="slider-img" :src="slide.imageUrlUa" :alt="'Slide ' + slide.id">
        <img v-else class="slider-img" :src="slide.imageUrlEng" :alt="'Slide ' + slide.id">
        <div class="slider-content">
          <h3 class="title-slider">{{ $t(slide.title) }}</h3>
          <p class="content-text-slider">{{ $t(slide.text) }}</p>
        </div>
      </div>
    </carousel>
    </b-container>
  </section>
</template>
<script>
import Carousel from 'vue-owl-carousel'
export default {
  components: {
    Carousel // Додаємо компонент Carousel
  },
  data () {
    return {
      slides: [
        {
          id: 1,
          imageUrlEng: require('@/assets/img/slide-1-en.png'),
          imageUrlUa: require('@/assets/img/slide-1-ua.png'),
          title: 'slider_title_1',
          text: 'slider_content_1'
        },
        {
          id: 2,
          imageUrlEng: require('@/assets/img/slide-2-en.png'),
          imageUrlUa: require('@/assets/img/slide-2-ua.png'),
          title: 'slider_title_2',
          text: 'slider_content_2'
        },
        {
          id: 3,
          imageUrlEng: require('@/assets/img/slide-3-en.png'),
          imageUrlUa: require('@/assets/img/slide-3-ua.png'),
          title: 'slider_title_3',
          text: 'slider_content_3'
        },
        {
          id: 4,
          imageUrlEng: require('@/assets/img/slide-4-en.png'),
          imageUrlUa: require('@/assets/img/slide-4-ua.png'),
          title: 'slider_title_4',
          text: 'slider_content_4'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.how-works-section{
  padding-top: 80px;
  padding-bottom: 80px;
  .title-how-works{
    color: #30394B;
    font-family: $main-font;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 48px */
    margin: 0 0 40px 0;
    @media screen and (min-width: 320px) {
      font-size: 32px;
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1440px) {
      font-size: 40px;
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .slider-content-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .slider-img{
      max-width: 240px;
      width: 100%;
      height: auto;
      @media screen and (min-width: 320px) {
        max-width: 152px ;
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
        max-width: 240px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .slider-content{
      display: flex;
      max-width: 240px;
      width: 100%;
      padding: 40px 0px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      align-self: stretch;
      @media screen and (min-width: 320px) {
        max-width: 165px ;
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
        max-width: 240px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
      .title-slider{
        color: #30394B;
        font-family: $main-font;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        margin: 0 0 16px 0;
        @media screen and (min-width: 320px) {
          font-size: 16px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 20px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .content-text-slider{
        color: #6D788C;
        font-family: $main-font;
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 150%;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 12px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
